import megaMenu from './megaMenu';

/** Init Header Functions */
export default function () {
    let analitycs = analyticstracker();

    if ($('.js-mega-menu').length > 0 || $('.js-mega-menu--products').length > 0) {
        megaMenu();
    }

    if ($('.js-tools-dropdown--trigger').length > 0) {
        toolsDropdown();
    }

    if ($('.js-preheader-contact-tracking').length > 0) {
        $('.js-preheader-contact-tracking a').on('click', (event) => {
            event.preventDefault();

            const eventData = {
                event: 'button-click',
                info: {
                    buttonType: 'link',
                    buttonCategory: 'inbound-link',
                    buttonName: 'to-contact',
                    buttonText: $(event.target).text(),
                    buttonTarget: $(event.target).attr('href'),
                    buttonPosition: 'preheader',
                },
            };

            analitycs.trackEvent(eventData);

            window.location.href = $(event.target).attr('href');
        });
    }


}

function toolsDropdown() {
    $('.js-tools-dropdown--trigger').on('click', function () {
        $(this).closest('.header__tools').toggleClass('active');
        $(this).siblings('.header__tools-container').slideToggle(300);
    });

    $(document).on('click', function (event) {
        if (!$(event.target).closest('.header__tools').length) {
            $('.header__tools').removeClass('active');
            $('.header__tools-container').slideUp(300);
        }
    });
}
